// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".background-overlay[data-v-38445bdc]{background:rgba(17,68,54,.768627451)!important;max-width:100%;z-index:999!important;text-align:center!important}", ""]);
// Exports
module.exports = exports;
